/**
 * Wager type enum.
 */
export enum WagerTypeEnum {
  Credits,
  Wallet,
}